import React, { CSSProperties } from 'react';
import { getTheme, Icon, mergeStyles, Stack, Text } from '@fluentui/react';
import { TooltipText } from 'components/shared/TooltipText';

export const UnsupportedContentType: React.FunctionComponent = (): JSX.Element => {
  const { palette, fonts } = getTheme();

  const ValidationMessageWrapperClass = mergeStyles(
    {
      backgroundColor: palette.neutralLighter
    },
    'h-100'
  );

  const IcontStyle: CSSProperties = {
    color: palette.red,
    fontSize: 16,
    lineHeight: '24px'
  };

  const UnsupportedMessageTitleStyle: CSSProperties = {
    color: palette.black,
    lineHeight: fonts.large.lineHeight
  };

  const UnsupportedMessageStyle: CSSProperties = {
    color: palette.neutralDark,
    fontFamily: 'inherit',
    lineHeight: fonts.large.lineHeight
  };

  return (
    <Stack className={ValidationMessageWrapperClass} tokens={{ childrenGap: 3 }}>
      <Stack.Item>
        <Icon style={IcontStyle} iconName={'ErrorBadge'} />
      </Stack.Item>
      <Stack.Item>
        <Text style={UnsupportedMessageTitleStyle} variant="large">
          {TooltipText.unsupportedContentTypeTitle}
        </Text>
      </Stack.Item>
      <Stack.Item>
        <Text style={UnsupportedMessageStyle} variant="large">
          {TooltipText.unsupportedContentTypeMessage}
        </Text>
      </Stack.Item>
    </Stack>
  );
};
